export const GET_CONTACT = '@CONTACT/GET_CONTACT'
export const UPDATE__STATUS_CONTACT = '@CONTACT/UPDATE__STATUS_CONTACT'
